import * as api from "./api";
import * as apiScope from "./apiScope";
import * as app from "./app";
import * as appDomain from "./appDomain";
import * as appFacadeImpl from "./appFacadeImpl";
import * as appRoleFacadeImpl from "./appRoleFacadeImpl";
import * as bizPermissionApply from "./bizPermissionApply";
import * as bizPermissionApplyRoles from "./bizPermissionApplyRoles";
import * as bizSecondaryAdminConfig from "./bizSecondaryAdminConfig";
import * as data from "./data";
import * as dimension from "./dimension";
import * as loginResourceSupportImpl from "./loginResourceSupportImpl";
import * as menu from "./menu";
import * as role from "./role";
import * as tableColumn from "./tableColumn";
import * as view from "./view";
import * as viewQuery from "./viewQuery";
import * as viewTable from "./viewTable";

export const appCenter = {
  api,
  apiScope,
  app,
  appDomain,
  appFacadeImpl,
  appRoleFacadeImpl,
  bizPermissionApply,
  bizPermissionApplyRoles,
  bizSecondaryAdminConfig,
  data,
  dimension,
  loginResourceSupportImpl,
  menu,
  role,
  tableColumn,
  view,
  viewQuery,
  viewTable,
};
